var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMogul = function SvgMogul(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.117,
    r: 10.353,
    stroke: "#00D286",
    strokeWidth: 1.294
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D286",
    d: "M11.838 16.413a.65.65 0 0 1-.672 0l-3.882-2.357a.65.65 0 0 1-.312-.553V8.731c0-.226.118-.435.312-.553l3.882-2.357a.65.65 0 0 1 .672 0l3.882 2.357a.65.65 0 0 1 .311.553v4.772a.65.65 0 0 1-.311.553z"
  })));
};
export default SvgMogul;